import { useGetUsersMeQuery } from 'react-common'
import { isOpenCatalog } from '@/utils/isOpenCatalog'
import { isPublicCertificate } from '@/utils/isPublicCertificate'

export const useAuth = () => {
  const { data: user, isLoading } = useGetUsersMeQuery(undefined, {
    skip: isOpenCatalog() || isPublicCertificate(),
  })

  return {
    user,
    isLoading,
  }
}
